module.exports = __webpack_public_path__ + "img/arrow-up-circle.4bf0e3b8.svg";